import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useAuth } from '../hooks/useAuth'

export default function AdminPage() {
  const { isAdmin, loading, user, signOut } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-ss-white flex items-center justify-center pt-16">
        <div className="w-8 h-8 border-2 border-ss-border border-t-ss-dark rounded-full animate-spin" />
      </div>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="min-h-screen bg-ss-white pt-16">
      <Helmet>
        <title>Администрирование — SwedenSound</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="mx-auto max-w-ss px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-light text-ss-text tracking-tight">
              Панель администратора
            </h1>
            <p className="text-sm text-ss-muted mt-1">
              Администратор — {user?.email}
            </p>
          </div>
          <button
            onClick={async () => {
              await signOut()
              window.location.href = '/'
            }}
            className="text-sm text-red-600 hover:text-red-800 font-medium px-4 py-2 border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
          >
            Выйти
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Link
            to="/catalog"
            className="rounded-xl bg-white border border-ss-border p-6 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5"
          >
            <h3 className="font-medium text-ss-text mb-1">Управление товарами</h3>
            <p className="text-sm text-ss-muted">Редактирование каталога</p>
          </Link>
          <div className="rounded-xl bg-white border border-ss-border p-6">
            <h3 className="font-medium text-ss-text mb-1">Заявки дилеров</h3>
            <p className="text-sm text-ss-muted">Рассмотрение заявок — в разработке</p>
          </div>
          <div className="rounded-xl bg-white border border-ss-border p-6">
            <h3 className="font-medium text-ss-text mb-1">Пользователи</h3>
            <p className="text-sm text-ss-muted">Управление ролями — в разработке</p>
          </div>
        </div>
      </div>
    </div>
  )
}
